import {fetchBaseQuery} from "@reduxjs/toolkit/query/react"

// Настойки для API Review
export const apiQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, {getState}) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const {auth:{token}} = getState()
        headers.set("Authorization", `Bearer ${token}`)
        return headers
    },
})

